import { render, staticRenderFns } from "./VeJwQkJiankaoList.vue?vue&type=template&id=96b7005e&scoped=true"
import script from "./VeJwQkJiankaoList.vue?vue&type=script&lang=js"
export * from "./VeJwQkJiankaoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b7005e",
  null
  
)

export default component.exports